module.exports = __webpack_public_path__ + "img/61_7.abdbcbda.png";